<a (click)="navigate()" class="text-decoration-underline" *ngIf="isWarn">{{params?.data.w}}
</a>

<span *ngIf="!isWarn">{{params?.data.w}}
</span>